import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";

export function useAddUpsCarrier(shopId: string) {
	const errorNotification = useFormErrorNotification();

	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/carriers/ups/login/{shopId}",
	);

	return useMutation({
		onSuccess: (response: { redirectUrl: string }) => {
			window.location.href = response.redirectUrl;
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: ({
			accountNumber,
			carrierType,
			carrierId,
		}: {
			accountNumber: string;
			carrierType: string;
			carrierId?: string;
		}) => {
			return mutation.mutateAsync({
				params: {
					path: { shopId },
					query: {
						accountNumber,
						carrierId,
						carrierType,
					},
				},
				// TODO: type API
			}) as unknown as Promise<{ redirectUrl: string }>;
		},
	});
}
